import Reservation, {IReservation} from "@/types/clients/esquire/data/general/reservation";

export default class LoginData {
  public contractStatus: string;
  public routes: Record<string, string>;
  public contractId: string;
  public units: Array<string>;
  public reservation: Reservation;

  constructor(data: Record<string, unknown>) {
    this.contractStatus = data.contract_status as string;
    this.routes = data.routes as Record<string, string>;
    this.contractId = data.contract_id as string;
    this.units = data.units as Array<string>;
    this.reservation = new Reservation(data.reservation as IReservation);
  }
}
